export default "__VITE_ASSET__7f45235a__"